var map = {
	"./screen1.png": 369,
	"./screen2.png": 370,
	"./screen3.png": 371,
	"./screen4.png": 372,
	"./screen5.png": 373,
	"./screen6.png": 374,
	"./screen7.png": 375,
	"./screen8.png": 376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;